import { Injectable } from '@angular/core';
import * as JSZip from 'jszip';
import { measureStoreAsync, measureStoreSync } from '../menu/store-performance';
import { headerParameter, parseMultipartBody } from './multipart';

@Injectable({ providedIn: 'root' })
export class CompressionService {
  async getMultipartFile(response: any): Promise<any> {
    const boundary = headerParameter(response?.headers?.get('Content-Type') ?? '', 'boundary');
    if (!boundary) throw new Error('Missing multipart boundary');
    if (!(response.body instanceof ArrayBuffer) && !ArrayBuffer.isView(response.body)) {
      throw new Error('Invalid multipart response body');
    }
    const body = response.body;
    const bytes = ArrayBuffer.isView(body)
      ? new Uint8Array(body.buffer, body.byteOffset, body.byteLength) : new Uint8Array(body);
    const parts = measureStoreSync('multipart-split', () => parseMultipartBody(bytes, boundary));
    const combined: any = {};
    for (const part of parts) {
      const mediaType = part.type.split(';')[0].trim().toLowerCase();
      if (mediaType !== 'application/json' && mediaType !== 'attachment') continue;
      const parameterName = /^\s*([^=\s]+)\s*=/.exec(part.type.split(';')[1] ?? '')?.[1];
      const name = parameterName && headerParameter(part.type, parameterName);
      if (!name) throw new Error('Missing multipart field name');
      let text: string;
      if (mediaType === 'application/json') {
        text = measureStoreSync('utf8-decode', () => new TextDecoder('utf-8').decode(part.data));
      } else {
        text = await measureStoreAsync('zip-decompress', async () => {
          const zip = await JSZip.loadAsync(part.data);
          let fileName: string;
          // Preserve the existing last-entry rule for archives with multiple files.
          zip.forEach(relativePath => { fileName = relativePath; });
          const file = fileName && zip.file(fileName);
          if (!file) throw new Error('Menu archive has no readable file');
          return file.async('string');
        });
      }
      const data = measureStoreSync('json-parse', () => JSON.parse(text));
      Object.defineProperty(combined, name, { value: data, writable: true, enumerable: true, configurable: true });
    }
    return combined;
  }
}
